import { useState } from 'react';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { roleCan } from '../../lib/access';
import { C } from '../../theme/palette';

/**
 * Carte « Importer une soumission » sans le Pack IA, comme la maquette : la
 * zone d'import et la mention du pack.
 *
 * <p>La maquette ouvrait une alerte qui promettait la fonction « à la mise en
 * ligne ». L'application est en ligne : l'appui explique ici que la lecture
 * fait partie du Pack IA et mène à l'abonnement, où il s'active. Rien n'est
 * envoyé au serveur de lecture tant que le pack n'est pas pris.
 *
 * @param {object} props propriétés de la carte
 * @param {Function} [props.onNav] navigation entre les pages
 * @returns {import('react').ReactElement} la carte
 */
export function ImportVerrouille({ onNav }) {
  const [ouvert, setOuvert] = useState(false);
  // L'abonnement est l'affaire du patron : la secrétaire, qui a les
  // soumissions mais pas l'abonnement, est invitée à le lui demander.
  const peutActiver = roleCan('abonnement');

  return (
    <Card style={{ marginBottom: 12 }}>
      <Bar icon="📥" title="Importer une soumission" color={C.teal} sub="Photo, scan ou PDF" />
      <div style={{ padding: 13 }}>
        <button
          type="button"
          aria-expanded={ouvert}
          onClick={() => setOuvert((v) => !v)}
          style={{
            display: 'block',
            width: '100%',
            border: '2px dashed ' + C.teal,
            background: C.tealL,
            color: C.teal,
            borderRadius: 12,
            padding: 15,
            textAlign: 'center',
            fontSize: 13,
            fontWeight: 800,
            cursor: 'pointer',
            marginBottom: 10,
          }}
        >
          📷 Importer une soumission (photo / PDF)
        </button>
        {ouvert && (
          <div
            role="region"
            aria-label="Lecture automatique des soumissions"
            style={{
              border: '1px solid ' + C.border,
              borderRadius: 11,
              padding: 12,
              marginBottom: 10,
              fontSize: 11,
              color: C.ink,
              lineHeight: 1.6,
            }}
          >
            <div style={{ fontWeight: 800, fontSize: 12, marginBottom: 6 }}>
              📄 Lecture automatique des soumissions
            </div>
            <div style={{ marginBottom: 6 }}>
              Cette fonction fait partie du <b>Pack IA</b>, en option de ton abonnement.
            </div>
            <div style={{ color: C.grey, marginBottom: 10 }}>
              Elle lit ta soumission, remplit les prix depuis ton catalogue (article inconnu : tu
              tapes juste le prix), et te signale les pièges (compte prorata, régie, rabais imposé,
              postes en option…).
            </div>
            {peutActiver ? (
              <Btn
                label="⭐ Activer le Pack IA"
                color={C.purple}
                full
                onClick={() => onNav && onNav('abonnement')}
              />
            ) : (
              <div style={{ fontSize: 10, color: C.muted }}>
                Demande au responsable de l’entreprise de l’activer dans Plus → Abonnement.
              </div>
            )}
          </div>
        )}
        <div
          style={{
            fontSize: 9.5,
            color: C.muted,
            lineHeight: 1.6,
            background: C.navyXL,
            borderRadius: 10,
            padding: 11,
          }}
        >
          🔒 <b>Lecture automatique avec le Pack IA</b> (en option, à activer dans Abonnement). L’IA
          lit la soumission → remplit tes prix depuis ton catalogue → te signale les pièges (même
          cachés dans le texte).
        </div>
      </div>
    </Card>
  );
}
